import { withTeamConfig } from "@/global/context/AppProviderRoot";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { routes } from "@/global/routes";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { HalfScreenBanner } from "@/shared/common/layouts/HalfScreenBanner";
import { TopHeaderLayout } from "@/shared/common/layouts/TopHeaderLayout";
import OptionsMenu from "@/shared/modules/OptionsMenu/OptionsMenu";
import { PurchaseCredit } from "@/shared/modules/PurchaseCredit/PurchaseCredit";
import { PurchaseCreditNavMenuItems } from "@/shared/modules/PurchaseCredit/purchaseCredit.navHelpers";
import { customFonts } from "@/global/theme/fonts";
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { useRouter } from "next/router";
import React from "react";

function PurchaseCreditPage() {
  const { sm: smDown } = useCssMediaQuery("down");
  const router = useRouter();
  const { purchaseCreditConfigs, defaultRoute, teamSchema, uiConfigs } = useTeamConfig(); // prettier-ignore
  const { isStandAlonePurchaseCreditEnabled } = purchaseCreditConfigs;
  const [isLoading, setIsLoading] = React.useState(true);
  const purchaseCreditTitle = uiConfigs?.purchaseCredit?.purchaseCreditTitle || "Purchase Credits"; // prettier-ignore
  const titleFontKey = uiConfigs?.purchaseCredit?.purchaseCreditTitleFont;
  const titleFontFamily = titleFontKey ? customFonts[titleFontKey] : undefined;

  React.useEffect(() => {
    (async () => {
      if (!isStandAlonePurchaseCreditEnabled) {
        await router.push({ pathname: defaultRoute, query: { teamSchema } });
      }
      if (isStandAlonePurchaseCreditEnabled) {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return (
      <Stack
        width={"100%"}
        height={"100vh"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <Box>
      <TopHeaderLayout
        renderRightElements={() => {
          return (
            <OptionsMenu
              renderDynamicItems={() => {
                return <PurchaseCreditNavMenuItems hidePurchaseCredit={true} />;
              }}
            />
          );
        }}
      />
      <HalfScreenBanner
        renderContent={() => {
          return (
            <Container sx={{ padding: smDown ? 0 : "inherit" }}>
              <Stack
                width={"100%"}
                alignItems={"center"}
                spacing={smDown ? 3 : 6}
                sx={{
                  pt: smDown ? 3 : 6,
                  pb: smDown ? 3 : 6,
                  position: "relative",
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      color: "white",
                      ...(titleFontFamily && { fontFamily: titleFontFamily }),
                    }}
                    fontWeight={700}
                    textAlign={"center"}
                  >
                    {purchaseCreditTitle}
                  </Typography>
                </Box>
                <Box>
                  <PurchaseCredit
                    authRedirectPath={routes.purchaseCredit}
                    skipRegister={true}
                    successModalCloseRedirectPath={routes.purchaseSeats}
                  />
                </Box>
              </Stack>
            </Container>
          );
        }}
      />
    </Box>
  );
}

export default withTeamConfig(PurchaseCreditPage);
